import { AuditAction } from '../../io/api/audit/data/AuditEntry'

type Operation =
  | 'Create'
  | 'Update'
  | 'Delete'
  | 'Recover'
  | 'Publish'
  | 'InviteUser'
  | 'Grant'
  | 'Revoke'
  | 'PermissionUpdate'

const operationOf = (action: AuditAction): Operation => {
  if (action.endsWith('Create')) return 'Create'
  if (action.endsWith('Delete')) return 'Delete'
  if (action.endsWith('Recover')) return 'Recover'
  if (action === 'EntityPublish') return 'Publish'
  if (action === 'EntityInviteUser') return 'InviteUser'
  if (action === 'PermissionGrant') return 'Grant'
  if (action === 'PermissionRevoke') return 'Revoke'
  if (action === 'PermissionUpdate') return 'PermissionUpdate'
  return 'Update'
}

const EMOJI: Record<Operation, string> = {
  Create: '✨',
  Update: '✏️',
  Delete: '🗑️',
  Recover: '♻️',
  Publish: '🚀',
  InviteUser: '✉️',
  Grant: '🔓',
  Revoke: '🔒',
  PermissionUpdate: '🔐',
}

export const actionEmoji = (action: AuditAction): string => EMOJI[operationOf(action)]
